import React from 'react'

class Checkbox extends React.Component {
  render() {
    const { checked, id, text, onClick } = this.props
    const isChecked = checked ? true : false;

    return (
      <div className='custom-control custom-checkbox mb-1'>
        <input
          id={id}
          className='custom-control-input'
          type="checkbox"
          checked={isChecked}
          onChange={onClick}
        />
        <label className="custom-control-label" htmlFor={id}>
          <span>{text}</span>
        </label>
      </div>
    )
  }
}

export default Checkbox;
